import React from 'react';
import { Carousel, Steps } from 'antd';
import SVG from 'react-inlinesvg';
import PropTypes from 'prop-types';
import {
  FileDoneOutlined,
  CloudUploadOutlined,
  UserAddOutlined,
} from '@ant-design/icons';


class AuthLayout extends React.Component {
  state = {
    current: 0,
  };

  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
    ]),
  };

  carouselBeforeChange = (from, to) => {
    if (to !== this.state.current) {
      this.setState({ current: to });
    }
  };

  render() {
    const svg1 = <SVG src={require('assets/media/auth/step-design.svg')} />;
    const svg2 = <SVG src={require('assets/media/auth/step-publish.svg')} />;
    const svg3 = <SVG src={require('assets/media/auth/step-lead.svg')} />;

    const carousel = (
      <Carousel
        autoplay beforeChange={this.carouselBeforeChange}
        dots={false} effect="scrollx"
      >
        <div>{svg1}</div>
        <div>{svg2}</div>
        <div>{svg3}</div>
      </Carousel>
    );

    const t1 = <h5>Build</h5>;
    const t2 = <h5>Publish</h5>;
    const t3 = <h5>Generate leads</h5>;

    const steps = (
      <Steps className="auth__layout_steps" direction="vertical" size="small" current={this.state.current}>
        <Steps.Step title={t1} icon={<FileDoneOutlined />} description="stunning landing pages in minutes." />
        <Steps.Step title={t2} icon={<CloudUploadOutlined />} description="on enterprise-grade servers for fast page loads." />
        <Steps.Step title={t3} icon={<UserAddOutlined />} description="Grow your business and increase campaign ROI." />
      </Steps>
    );

    return (
      <div className="app__auth_layout d-flex flex-column justify-content-between">

        <div className="auth__header text-center d-flex align-items-center justify-content-center">
          <SVG className="auth_logo" src={require('assets/media/brand/logo-app-navbar.svg')} />
        </div>

        <div className="auth__content container py-3 d-flex flex-column justify-content-around">
          <div className="row align-items-center">
            <div className="my-4 col-12 col-sm-9 col-md-6 col-lg-5 col-xl-4 mx-auto order-lg-2">
              {this.props.children}
            </div>
            <div className="my-5 my-lg-4 col-12 col-sm-9 col-md-10 col-lg-7 col-xl-8 mx-auto order-lg-1">
              <div className="d-flex flex-row align-items-center justify-content-center">
                <div className="auth__carousel_wrapper d-none d-md-block d-lg-none d-xl-block mr-5">
                  {carousel}
                </div>
                <div className="auth__steps_wrapper mx-auto mx-md-0">
                  <h4 className="mb-4">Everything you need to</h4>
                  {steps}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="auth__footer d-flex align-items-center justify-content-center">
          <div className="text-muted small">
            ©2019 Created by PageHits
          </div>
        </div>

      </div>
    );
  }
}

export default AuthLayout;



// WEBPACK FOOTER //
// ./scripts/layouts/AuthLayout.jsx